// Isolated fetch boundary: no shared axios/auth interceptors, redirects, cookies,
// request telemetry or raw-error propagation. No requests are made on creation.
export function createLifecycleRecoveryTransport({ baseUrl, fetchImpl = typeof window === 'undefined' ? undefined : window.fetch?.bind(window),
  getInitiationAuthorization }) {
  const base = new URL(baseUrl);
  if (!['http:', 'https:'].includes(base.protocol) || base.username || base.password ||
      base.search || base.hash || base.pathname !== '/') throw new TypeError('invalid_lifecycle_origin');
  const call = async (kind, headers) => {
    try {
      const requestHeaders = {
        'Account-Lifecycle-Operation-Id': headers['Account-Lifecycle-Operation-Id'],
        'Account-Lifecycle-Credential': headers['Account-Lifecycle-Credential'],
        ...(kind !== 'status' ? { 'Idempotency-Key': headers['Idempotency-Key'] } : {}),
      };
      if (kind === 'initial') {
        const authorization = await getInitiationAuthorization();
        if (!authorization) throw new Error();
        requestHeaders.Authorization = authorization;
      }
      const path = kind === 'initial' ? '/api/users/me' : `/api/users/account-closure/${kind}`;
      const response = await fetchImpl(new URL(path, base).href, {
        method: kind === 'initial' ? 'DELETE' : kind === 'status' ? 'GET' : 'POST',
        headers: requestHeaders, credentials: 'omit', redirect: 'error', cache: 'no-store',
        referrerPolicy: 'no-referrer',
      });
      return { status: response.status, data: await response.json() };
    } catch (_) { throw new Error('lifecycle_transport_unavailable'); }
  };
  return Object.freeze(Object.fromEntries(['initial', 'status', 'replay'].map(kind =>
    [kind, ({ headers }) => call(kind, headers)])));
}
